<template>
  <section>
    <top-menu/>
    <modal-password subtitle-modal="Informe a senha para continuar:" title-modal="Acesso" :disabledButton="true"
                    :remove-close-button="true"
                    :run-function="handleAccess"/>

    <section>
      <div class="page-content">
        <div class="container-fluid">
          <full-loading v-if="loadingBenefits"/>

          <div v-if="!loadingBenefits && access" class="row first__row">
            <div class="col-md-6 card">
              <div class="col-md-12 card__content">
                <div class="card__content__header">
                  <span class="card__content__header--title">
                      Transferência via PIX (saldo livre)
                  </span>
                </div>
                <div class="row card__content__body">
                  <div class="col-md-12">
                    <input-text col="12" type="text" placeholder="Chave PIX" label="Chavi PIX:"
                                @contentText="value => pixKey = value"/>
                  </div>
                  <div class="col-md-12">
                    <input-text col="12" type="text" placeholder="ID do usuário" label="ID do usuário:"
                                @contentText="value => idToSend = value"/>
                  </div>
                  <div class="col-md-12">
                    <input-text col="5" type="text" placeholder="Valor" label="Valor:" :has-mask-money="true"
                                @contentText="value => amount = value"/>
                  </div>
                  <div class="col-md-12 card__content__body-button">
                    <btn-custom col="12" label="Transferir" width="100%" @emit-click="verifyKey" :have-loading="true"
                                :loading="loadingButton"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import BtnCustom from "../../components/buttons/btnCustom.vue";
import inputText from "../../components/inputs/inputText.vue";
import {REQUEST_SERVICE, UTIL_SERVICE} from "../../../../requestConfig";
import {ACCESS_PAYMENT_PIX, CONFIRM_PIX_ORDER, VALIDATE_PIX_KEY} from "../../../../urlConfig";
import axios from "axios";
import swal from "sweetalert";
import ModalPassword from "../../modals/modalPassword.vue";

export default {
  name: "benefits-pix",
  components: {
    ModalPassword,
    topMenu,
    pageHeader,
    fullLoading,
    BtnCustom,
    inputText,
  },
  data() {
    return {
      access: false,
      loadingBenefits: false,
      loadingButton: false,
      idToSend: '',
      userId: '',
      pixKey: '',
      amount: '',
    };
  },
  computed: {
    amountFormatted: function () {
      return parseFloat(this.amount.replace(/R\$|\s|,/g, ''));
    }
  },
  methods: {
    confirmOrder(value) {
      if (value) {
        this.loadingBenefits = true;
        const obj = {
          userId: this.idToSend,
          pixKey: this.pixKey,
          amount: this.amountFormatted,
        }
        REQUEST_SERVICE.post(CONFIRM_PIX_ORDER, obj).then((response) => {
          UTIL_SERVICE.console('RESULT CONFIRM_PIX_ORDER: ', response.data);
          this.loadingBenefits = false;
          if (response.data.status === 1) {
            swal("Sucesso", `O valor de R$ ${response.data.amount} foi depositado para ${response.data.sendTo}`, "success");
          }
          if (response.data.status === 2) {
            swal("Aviso!", "Ocorreu um problema, tente novamente mais tarde!", "warning");
          }
          if (response.data.status === 3) {
            swal({
              title: "Sucesso!",
              icon: 'success',
              content: {
                element: "div",
                attributes: {
                  innerHTML: `
                  <div style="display: flex; flex-direction: column; align-items: flex-start; text-align: left">
                    <p style="margin: 4px auto">O valor: <b>R$ ${response.data.amount}</b> foi enviado para:</p>
                    <p style="margin: 4px auto"><b>${response.data.sendTo}</b></p>
                    <p style="margin: 8px auto 4px auto">Código da transação:</p>
                    <p style="margin: 4px auto"><b>${response.data.transactionId}</b></p>
                  </div>`,
                }
              },
            });
          }
        }).catch((reason) => {
          UTIL_SERVICE.console('RESULT CONFIRM_PIX_ORDER: ', reason.data);
          this.loadingBenefits = false;
          swal("Erro!", "Ocorreu um erro interno, entre em contato com o suporte.", "error");
        })
      } else {
        swal("Aviso", 'O campo "confirmar" não foi preenchido corretamente!', "warning");
      }
    },
    handleAccess(password) {
      if (!password) return;
      this.loadingBenefits = true;
      const url = ACCESS_PAYMENT_PIX + `?userid=${this.userId}&pass=${password}`;
      REQUEST_SERVICE.get(url).then((response) => {
        UTIL_SERVICE.console('RESULT GET_ACCESS_PAYMENT_PIX: ', response.data);
        if (response.status === 200) {
          this.access = response.data.access;
          $('#password-modal').modal('hide');
        }
        if (response.status === 204) {
          swal("Aviso!", "A senha informada está incorreta!", "warning").then(() => {
            location.reload();
          });
        }
        this.loadingBenefits = false;
      }).catch((reason) => {
        this.loadingBenefits = false;
        swal("Erro", "Usuário não encontrado.", "error").then(() => {
          location.reload();
        });
      })
    },
    verifyKey() {
      this.loadingButton = true;
      const URL = VALIDATE_PIX_KEY + `/${this.pixKey}/verify?userId=${this.idToSend}`;
      REQUEST_SERVICE.get(URL).then((response) => {
        UTIL_SERVICE.console('RESULT VALIDATE_PIX_KEY: ', response.data);
        this.loadingButton = false;
        swal({
          title: "Aviso!",
          text: `Confirme os dados da transferência`,
          content: {
            element: "div",
            attributes: {
              innerHTML: `
            <div style="display: flex; flex-direction: column; align-items: flex-start; text-align: left">
              <p style="margin: 4px 0"><b>Banco:</b> ${response.data.receiverBankName}</p>
              <p style="margin: 4px 0; max-wid"><b>Destinatário:</b> ${response.data.receiverName}</p>
              <p style="margin: 4px 0"><b>CPF/CNPJ:</b> ${response.data.receiverDocumentMask}</p>
              <p style="margin: 4px 0"><b>Saldo:</b> ${response.data.dockBalance}</p>
              <div style="width: 100%; margin-top: 16px"><input type="text" name="confirm" id="confirm" placeholder='Digite "confirmar" para prosseguir' style="width: 100%; outline: none; border: 1px solid #d6d6d6; border-radius: 8px !important; height: 42px; padding: 4px 12px;"></div>
            </div>`,
            }
          },
          buttons: true,
          dangerMode: true
        }).then((value) => {
          if (value) {
            const inputValue = document.querySelector('#confirm').value;
            if (inputValue.toLowerCase() === 'confirmar') {
              this.confirmOrder(true);
            } else {
              this.confirmOrder(false);
            }
          }
        })
      }).catch((reason) => {
        this.loadingButton = false;
        swal("Aviso", reason.data, "warning");
      })
    }
  },
  mounted() {
    $('#password-modal').modal();
    setTimeout(() => {
      if (this.$route.params.userInfo) this.userId = this.$route.params.userInfo.id;
    }, 1500)
  },
};
</script>

<style lang="scss" scoped>

.swal-overlay {
  .swal-modal {
    width: 670px !important;
  }
}

.container-fluid {
  margin-top: 28px;

  .first__row {
    display: flex;;
    justify-content: center;

    .card {
      margin-bottom: 30px;

      .card__content {
        background: var(--classic-white);
        border-radius: 10px !important;
        padding: 20px;
        position: relative;
        border: 2px solid transparent;

        .card__content__header {
          text-align: center;
          margin-bottom: 28px;

          .card__content__header--title {
            font-size: 16px;
            font-weight: 700;
            color: var(--dark-black);

            .card__content__header--href {
              font-size: 14px;
              font-weight: 500;
              color: var(--high-blue);
              margin-left: 10px;
            }
          }
        }

        .card__content__body {
          height: 82%;
          margin-bottom: 16px;

          &-button {
            margin-top: 48px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/benefits/benefits-pix.vue